// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"691711a2","122":"0d255b44","261":"46376592","427":"840ffba1","462":"cbb7390a","624":"39f6731d","712":"988e1f20","791":"185c25f0","831":"4882e693","958":"80821786"}[chunkId] + ".chunk.js";
};